import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import './index.scss';
import BixbyQuillWrapper from '$/components/quill';
import InputBlock from '$/components/global/inputBlock';
import { Field, Formik, FormikProps } from 'formik';
import { updateDocumentAnnouncement } from '$/store/company/actions';

interface IDocumentAnnouncementProps {
  isLoadingDocumentAnnouncement: boolean;
  currentCompany?: Bixby.Models.AdminCompany;
  dispatchUpdateDocumentAnnouncement: (companyId: string, announcements: string) => void;
}

export interface DocumentAnnouncementValues {
  anouncements: string;
}

const DocumentAnnouncement: React.FC<IDocumentAnnouncementProps> = props => {
  const { currentCompany, dispatchUpdateDocumentAnnouncement, isLoadingDocumentAnnouncement } = props;
  const [initialFormValues, setInitialFormValues] = useState({} as DocumentAnnouncementValues);

  useEffect(() => {
    if (currentCompany && !Bixby.Utils.isNullOrEmpty(currentCompany)) {
      setInitialFormValues({
        anouncements: currentCompany.documentAnnouncement || '',
      });
    }
  }, [currentCompany]);

  const formikRef = useRef<FormikProps<DocumentAnnouncementValues>>(null);

  const parser = new DOMParser();
  const setDocumentAnnouncement = (form: any, content: string) => {
    let { textContent } = parser.parseFromString(content, 'text/html').documentElement;
    if (textContent != null && Bixby.Utils.isDefined(textContent) && textContent?.trim()?.length <= 0) {
      textContent = '';
    } else {
      textContent = content;
    }
    form.setFieldValue('anouncements', textContent);
  };

  return !Bixby.Utils.isNullOrEmpty(initialFormValues) ? (
    <div className="document-announcement">
      <Formik
        innerRef={formikRef}
        initialValues={initialFormValues}
        enableReinitialize
        onSubmit={(values: DocumentAnnouncementValues) => {
          if (currentCompany) {
            dispatchUpdateDocumentAnnouncement(currentCompany.id, values.anouncements);
          }
        }}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <h3>Document Announcements</h3>
            <InputBlock>
              <Field
                name="anouncements"
                disabled={isLoadingDocumentAnnouncement}
                render={({ field, form }: { [key: string]: any }) => {
                  return (
                    <BixbyQuillWrapper
                      value={field.value}
                      onBlur={() => {
                        setDocumentAnnouncement(form, field.value);
                      }}
                      onChange={content => setDocumentAnnouncement(form, content)}
                      readOnly={isLoadingDocumentAnnouncement}
                    />
                  );
                }}
              />
            </InputBlock>
            {
              <button className="bix_button" type="submit" disabled={isLoadingDocumentAnnouncement}>
                Save
              </button>
            }
          </form>
        )}></Formik>
    </div>
  ) : null;
};

const mapStateToProps = (state: AppState) => {
  return {
    isLoading: state.companyState.isLoading,
    currentCompany: state.companyState.currentCompany,
    isLoadingDocumentAnnouncement: state.companyState.isLoadingDocumentAnnouncement,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchUpdateDocumentAnnouncement: (companyId: string, notes: string) =>
    dispatch(updateDocumentAnnouncement(companyId, notes)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentAnnouncement);
